import React,{useState, useEffect} from 'react'
import axios from 'axios'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { rollIn, fadeIn } from 'react-animations'
import styled, { keyframes } from 'styled-components';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import { set } from 'draft-js/lib/EditorState';

const Answer = (props, value, limit) => {
  const [textAnswer, setTextAnswer] = useState("")
  const handleNext=()=>{
   
  }

  const handlePrevious=()=>{
    
  }

  var words = textAnswer.split(' ')

    const handleSubmitClick= ()=>{
      if(words.length == ""){
        alert("Please enter some text");
      }
      else if(words.length < 80){
        alert("Please enter at least 80 words");
      }
      else{
        confirmAlert({
          title: 'Are you sure you want to submit your answer?',
          message: 'You cannot rollback this decision.',
          buttons: [
            {
              label: 'Yes',
              className: 'btn btn-primary',
              onClick: () => {
                submitYourAnswer();
              }
            },
            {
              label: 'No'
            }
          ]
        });
      }
    }

    const submitYourAnswer= async ()=>{
      if(textAnswer){
        console.log(props.VideoUrl);
        if(words.length > 80){
          axios.post('/assessment/answer',{
            Id: props.Id,
            Answer: textAnswer
          })
          .then(function (response) {
            props.removeActiveItem();
          })
          .catch(function (error) {
            console.error(error);
          });
        }
        else{
          alert("Please enter at least 80 words");
        }
     }
     else{
       props.setActiveItem(null);
     }
    }

    // const playVideo=()=>{
    //   var videoElement = document.getElementById('vd');  
    //   videoElement.play();
    // }

const handleCloseClick=()=>{
  props.setActiveItem(null);
}

const handlePreviousClick=()=>{
  props.previousSituation();
}

const handleNextClick=()=>{
  props.nextSituation();
}

const styles = {
  largeIcon: {
    height: 30,
    width: 30,
    padding: 5
  }
};

const tx = document.getElementsByTagName("textarea");
for (let i = 0; i < tx.length; i++) {
  tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight) + "px; overflow-y:hidden;");
  tx[i].addEventListener("input", OnInput, false);
}

function OnInput() {
  // textAnswer.style.height = 0;
  // textAnswer.style.height = (textAnswer.scrollHeight) + "px";
}

  return (
    <div className="row">
      <div className="col-lg-10 col-md-12 col-sm-12">
      {props.VideoUrl != null && props.VideoUrl != "" && props.ShowVideo == true ?
      <Tabs>
          <TabList>
            <Tab><PlayCircleIcon/> Watch Video</Tab>
            <Tab><LocalLibraryIcon/> Read Text</Tab>
          </TabList>
          <TabPanel> 
            <video controls width="100%" height="auto" autoPlay={true}>
            <source src={axios.defaults.baseURL + '/' + props.VideoUrl} type="video/mp4"/>
            </video>
          </TabPanel>
          <TabPanel>
            <div className="text-description" style={{width: "100% ", height:"auto", whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{__html: props.Description}}></div>
          </TabPanel>
          <br/>
      </Tabs>
      :
      <Tabs>
      <TabList>
        <Tab><LocalLibraryIcon/> Read Text</Tab>
      </TabList>
      <TabPanel>
        <div className="text-description" style={{width: "100% ", height:"auto",whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{__html: props.Description}}></div>
      </TabPanel>
      <br/>
  </Tabs>
}
      
        {/* <div className="btn-group">
          { props.Sequence > 0 &&  <button className="btn btn-outline-secondary" onClick={handlePreviousClick}><ArrowBackIcon/> Previous</button> }
            <button className="btn btn-outline-secondary" onClick={handleNextClick}><ArrowForwardIcon/> Next</button>
          </div> */}
          <div className="text-answer">
            <p>Write complete sentences for better understanding and evaluation of your response. Please respond with the actions you will take in this situation. The accuracy of the assessment depends on action you would take. So please avoid giving your views or thoughts about the situation. Refrain from using bullets, special characters, abbreviations, and numbers. Go to the next line or use a full stop only when you have completed a meaningful sentence. </p>
            <h5>Write your response below in the space provided:</h5>
            <textarea className="form-control" rows={3} autoFocus autoCorrect='off' spellCheck="false" data-enable-grammarly="false" data-gramm="false" onChange={e=> setTextAnswer(e.target.value)}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            ></textarea>

          </div>
        <div className="btn-group btn-group-justified mt-4">
          <button className="btn btn-primary" onClick={handleSubmitClick}>Submit</button>
          <button className="btn btn-secondary" onClick={handleCloseClick}>Close</button>
        </div>
        </div>
    </div>
    
  )
}

export default Answer
